import React, { useState, useEffect, useContext } from "react";
import "../../css/CRUDModal.css";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import confetti from "canvas-confetti";
import { BankNameContext } from "../../context/BankNameContext";

import { setBalance } from "../store/balance/balanceSlice";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { GrAttachment } from "react-icons/gr";
import AuthorizationModal from "../authorizationModal/authorizationModal";

const TopUpWalletModal = ({
  show,
  handleClose,
  customerData,
  fetchData,
  editData,
  action,
  utrNo,
  customerCode,
  customerName,
  smsBalance,
  bankName,
  columnData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const dispatch = useDispatch();
  const { bankNames, loading, error } = useContext(BankNameContext);
  const [formData, setFormData] = useState({
    topupAmount: "",
    totalAmount: 0,
    bankName: "",
    txnDate: "",
    payMode: "",
    utrNo: "",
    attachment: null,
    companybankName: "",
    accNo: "",
    ifsc: "",
  });
  const [errors, setErrors] = useState({
    topupAmount: "",
    bankName: "",
    txnDate: "",
    payMode: "",
    utrNo: "",
    attachment: "",
    companybankName: "",
    accNo: "",
    ifsc: "",
  });
  const [currentMainBalance, setCurrentMainBalance] = useState(
      (editData?.isAddingForPartner === true ? customerData?.partnerWalletBalance : customerData?.mainWalletBalance) || "0"
  );

  const [isLoading, setIsLoading] = useState(false);
  const [accData, setAccData] = useState(null);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const userRole = sessionStorage.getItem("userRole");

  const modalTitle = "Top-up Main Wallet";
  // const GST_RATE = 0.18;

  // Helper function to format number with commas and two decimals
  // const formatNumberWithCommas = (number) => {
  //   if (!number && number !== 0) return "";
  //   const num = parseFloat(number);
  //   if (isNaN(num)) return "0.00";
  //   return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // };

  const formatNumberWithCommas = (number) => {
    if (!number && number !== 0) return "";
    const num = parseFloat(number.toString().replace(/,/g, ""));
    if (isNaN(num)) return "0.00";
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    if (action === "add") {
      // Reset form when modal is opened or closed
      setFormData({
        topupAmount: "",
        totalAmount: 0,
        bankName: "",
        txnDate: "",
        payMode: "",
        utrNo: "",
        attachment: null,
        companybankName: "",
        accNo: "",
        ifsc: "",
      });
    } else if (action === "modify" || action === "check") {
      setFormData({
        ...editData,
        username: loggedInUserName,
        topupAmount: columnData?.amount,
        totalAmount: columnData?.customerNewBalance,
        bankName: columnData?.customerBankName,
        txnDate: columnData?.txnDate,
        payMode: columnData?.payMode,
        utrNo: columnData?.utrNo,
        attachment: null,
        companybankName: columnData?.bankName,
        accNo: columnData?.companyAccNo,
        ifsc: columnData?.companyBankIfsc,
        userId: columnData?.username,
        companyId: columnData?.customerId,
        companyName: columnData?.customerCompanyName,
      });
    }
    setErrors({
      topupAmount: "",
      bankName: "",
      txnDate: "",
      payMode: "",
      utrNo: "",
      attachment: "",
      companybankName: "",
      accNo: "",
      ifsc: "",
    });
    // Update displayed balance when customerData changes
    setCurrentMainBalance((editData?.isAddingForPartner === true ? customerData?.partnerWalletBalance : customerData?.mainWalletBalance) || "0");
  }, [show, customerData]);

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isAuth = action === "auth";
  const isEditMode = action === "modify";
  const isCheck = action === "check";
  const isReadOnly = isViewMode || isDeleteMode || isAuth || isCheck;
  const isMakerChecker = userRole === "ACCMK" || userRole === "ACCCH";
  console.log("::isMakerChecker::", isMakerChecker);

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    if (id === "topupAmount") {
      const updatedValue = value.replace(/[^0-9.]/g, ""); // Only allow numbers and decimals
      const amount = parseFloat(updatedValue) || 0; // Convert to number for calculations

      // // Calculate Total Amount with 18% GST
      // const gstAmount = amount * GST_RATE;
      // const totalAmount = amount + gstAmount;

      // Calculate Total Amount as Main Wallet Balance + Top-up Amount (no GST)
      const totalAmount = (parseFloat(currentMainBalance) || 0) + amount;

      // Real-time validation for RTGS
      let topupError = "";
      if (formData.payMode === "RTGS" && amount < 200000 && amount > 0) {
        topupError =
          "For RTGS transactions, the amount must be at least ₹2,00,000";
      } else if (
        updatedValue &&
        !/^\d{1,7}(\.\d{1,2})?$/.test(updatedValue) &&
        action !== "modify"
      ) {
        topupError =
          "Amount must be a number with a maximum of 7 digits and up to 2 decimals";
      }

      setFormData({
        ...formData,
        [id]: updatedValue,
        totalAmount: totalAmount.toFixed(2),
      });

      setErrors((prev) => ({
        ...prev,
        topupAmount: topupError,
      }));
    } else if (id === "companybankName") {
      const selectedBank = accData?.find((bank) => bank.bankName === value);

      if (selectedBank) {
        setFormData((prev) => ({
          ...prev,
          companybankName: selectedBank.bankName,
          accNo: selectedBank.accountNumber,
          ifsc: selectedBank.ifscCode,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          companybankName: value,
          accNo: "",
          ifsc: "",
        }));
      }
    } else if (id === "payMode") {
      // Re-validate topupAmount when payMode changes to RTGS
      const amount = parseFloat(formData.topupAmount) || 0;
      let topupError = "";
      if (value === "RTGS" && amount < 200000 && amount > 0) {
        topupError =
          "For RTGS transactions, the amount must be at least ₹2,00,000";
      } else if (
        formData.topupAmount &&
        !/^\d{1,7}(\.\d{1,2})?$/.test(formData.topupAmount) &&
        action !== "modify"
      ) {
        topupError =
          "Amount must be a number with a maximum of 7 digits and up to 2 decimals";
      }

      setFormData({
        ...formData,
        [id]: value,
      });

      setErrors((prev) => ({
        ...prev,
        topupAmount: topupError,
      }));
    } else {
      setFormData({
        ...formData,
        [id]: value,
      });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file is an image
      if (!file.type.startsWith("image/")) {
        setErrors((prev) => ({
          ...prev,
          attachment:
            "Only image files are allowed (e.g., JPG, JPEG, PNG, GIF).",
        }));
        setFormData((prev) => ({
          ...prev,
          attachment: null,
        }));
        e.target.value = ""; // Clear the input
        return;
      }
      // ✅ Check file size (2 MB = 2 * 1024 * 1024 bytes)
      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {
        setErrors((prev) => ({
          ...prev,
          attachment: "File size must not exceed 2 MB.",
        }));
        setFormData((prev) => ({
          ...prev,
          attachment: null,
        }));
        e.target.value = ""; // Clear the input
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        // Send the full data URL (including prefix) to match Postman
        const fullDataURL = reader.result;
        setFormData({
          ...formData,
          attachment: fullDataURL,
        });
        setErrors((prev) => ({
          ...prev,
          attachment: null,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setFormData({
        ...formData,
        attachment: null,
      });
    }
  };

  const validate = () => {
    const newErrors = {};

    // Top-up Amount Validation
    if (!formData.topupAmount) {
      newErrors.topupAmount = "Top-up Amount is required";
    } else if (
      !/^\d{1,7}(\.\d{1,2})?$/.test(formData.topupAmount) &&
      action !== "modify"
    ) {
      newErrors.topupAmount =
        "Amount must be a number with a maximum of 7 digits and up to 2 decimals";
    } else if (
      formData.payMode === "RTGS" &&
      parseFloat(formData.topupAmount) < 200000
    ) {
      newErrors.topupAmount =
        "For RTGS transactions, the amount must be at least ₹2,00,000";
    }

    // Bank Name Validation
    if (!formData.bankName) {
      newErrors.bankName = "Company Bank Name is required";
    }

    // Transaction Date Validation
    if (!formData.txnDate) {
      newErrors.txnDate = "Transaction Date is required";
    }

    // Payment Mode Validation
    if (!formData.payMode) {
      newErrors.payMode = "Payment Mode is required";
    }

    // UTR No Validation
    if (!formData.utrNo) {
      newErrors.utrNo = "UTR No/Txn No is required";
    } else if (formData.utrNo.length < 8 || formData.utrNo.length > 22) {
      newErrors.utrNo =
        "UTR No/Txn No must be between 8 and 22 characters.";
    }

    // Attachment Validation
    if (!formData.attachment && action !== "modify") {
      newErrors.attachment = "Attachment is required";
    }

    if (!formData.companybankName) {
      newErrors.companybankName = "Bank Name is required";
    }

    return newErrors;
  };

  // const formatDateToDDMMYYYY = (dateString) => {
  //   if (!dateString) return "";
  //   const date = new Date(dateString);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = date.getFullYear();
  //   return `${day}-${month}-${year}`;
  // };

  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";

    // Check if input is already in DD-MM-YYYY format
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      // Convert DD-MM-YYYY to YYYY-MM-DD
      const [day, month, year] = dateString.split("-");
      dateString = `${year}-${month}-${day}`;
    }

    const date = new Date(dateString);
    if (isNaN(date)) return "Invalid Date";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const refetchCustomerData = async () => {
    try {
      const requestBody = {
        username: loggedInUserName,
        status: "1",
      };

      const response = await axiosPostApi(
        apiList.FETCH_CUSTOMER_DATA,
        requestBody
      );
      if (response?.status === 200 && response?.data?.data) {
        const latestBalance = (editData?.isAddingForPartner === true ? response?.data?.data[0]?.partnerWalletBalance : response?.data?.data[0]?.mainWalletBalance) || "0";
        setCurrentMainBalance(latestBalance); // Update displayed balance
        return parseFloat(latestBalance);
      } else {
        throw new Error("Failed to fetch latest customer data");
      }
    } catch (error) {
      console.error("Error refetching customer data:", error);
      // CustomAlert({
      //   title: "Error",
      //   text: "Failed to fetch the latest wallet balance. Please try again.",
      //   icon: "error",
      //   confirmButtonText: "Retry",
      // });
      return parseFloat((editData?.isAddingForPartner === true ? customerData?.partnerWalletBalance : customerData?.mainWalletBalance) || 0); // Fallback to original balance
    }
  };
  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    // setLoading(true);

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
          fetchData(1, customerData?.customerCode);
        } else {
          // Handle error case here if necessary
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      // Refetch the latest customer data to get the current main balance
      const latestMainBalance = await refetchCustomerData();

      let apiUrl = "";
      if (action === "add") {
        apiUrl = apiList.CREATE_TOPUP_WALLET;
      } else if (action === "modify") {
        apiUrl = apiList.MODIFY_WALLET_TOPUP_REQUEST;
      }

      const payload = {
        username: loggedInUserName,
        customerCode: customerData?.customerCode,
        customerName: customerData?.name,
        oldMainBalance: latestMainBalance.toFixed(2), // Use the freshly fetched balance
        topupAmt: parseFloat(formData?.topupAmount),
        totalAmount: parseFloat(formData?.totalAmount),
        customerBankName: formData.bankName,
        companyBankName: formData?.companybankName,
        companyAccountNo: formData?.accNo,
        companyIfscCode: formData?.ifsc,
        bankName: formData?.bankName,
        txnDate: formatDateToDDMMYYYY(formData?.txnDate),
        payMode: formData?.payMode,
        utrNo: formData?.utrNo,
        attachment: formData?.attachment,
        isAddingForPartner: editData?.isAddingForPartner === true,
        ...(action === "modify" && { id: columnData?.id }),
      };

      console.log("Submitting payload:", payload); // Add logging for debugging
      axiosPostApi(apiUrl, payload)
        .then((response) => {
          console.log("Response:", response.data); // Add logging for debugging
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              // title: `${modalTitle} created successfully.`,
              title: response?.data?.message,
              text: "Your main balance will be updated soon. Till then, your amount will be in the unclear balance.",
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            });
            // Add confetti effect
            const canvas = document.createElement("canvas");
            canvas.style.position = "fixed";
            canvas.style.top = "0";
            canvas.style.left = "0";
            canvas.style.width = "100%";
            canvas.style.height = "100%";
            canvas.style.zIndex = "3000";
            document.body.appendChild(canvas);

            const confettiInstance = confetti.create(canvas, {
              resize: true,
              useWorker: true,
            });

            confettiInstance({
              particleCount: 250,
              spread: 100,
              origin: { y: 0.6 },
            });

            setTimeout(() => {
              document.body.removeChild(canvas);
            }, 3000);

            handleClose();
            handleClearData();
          }
          // else if (response?.status === 200 && !response?.data?.status) {
          //   CustomAlert({
          //     title: "Failed to Request",
          //     text: "Your request has been accepted successfully. Your main balance will be updated soon. Till then, your amount will be in the unclear balance.",
          //     icon: "success",
          //     confirmButtonText: "OK",
          //     showCloseButton: true,
          //     onConfirm: () => {
          //       fetchDashboardData();
          //     },
          //   });

          // }
          else if (response?.status === 200 && !response?.data?.status) {
            CustomAlert({
              title: "Failed to Request",
              text: response.data.message,
              icon: "error",
              confirmButtonText: "Retry",
            });
          }

          if (response?.data?.respCode === "02") {
            CustomAlert({
              title: "Warning",
              text:
                response?.data?.message || "Unable to proceed, Request again",
              icon: "warning",
              confirmButtonText: "Okay",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing Wallet request:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while adding the Wallet request. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
    setFormData({
      topupAmount: "",
      totalAmount: 0,
      bankName: "",
      txnDate: "",
      payMode: "",
      utrNo: "",
      attachment: null,
      companybankName: "",
      accNo: "",
      ifsc: "",
    });
  };

  const handleClearData = () => {
    setFormData({
      topupAmount: "",
      totalAmount: 0,
      bankName: "",
      txnDate: "",
      payMode: "",
      utrNo: "",
      attachment: null,
      companybankName: "",
      accNo: "",
      ifsc: "",
    });
  };

  const authMainWalletRequest = async (authData) => {
    try {
      const payload = {
        username: loggedInUserName,
        customerCode: customerCode || columnData?.customerId,
        utrNo: utrNo || columnData?.utrNo,
        bankName: bankName || columnData?.bankName,
        // status: authData?.approvalStatus === "reject" ? "5" : "1",
        status:
          authData?.approvalStatus === "reject"
            ? "5"
            : action === "check"
            ? "2"
            : "1",
        adminRemark: authData?.remark,
      };

      const response = await axiosPostApi(
        apiList.AUTH_MAIN_WALLET_REQ,
        payload
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        authData?.approvalStatus === "reject"
          ? CustomAlert({
              title: response?.data?.message,
              icon: "info",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            })
          : action === "check"
          ? CustomAlert({
              title: `Approved`,
              text: `Request submitted to checker for final authorization`,
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            })
          : CustomAlert({
              title: `Request has been accepted successfully.`,
              // text: `Customer wallet has been topped up with ₹${columnData?.amount}. Customer current wallet balance is ₹${columnData?.customerNewBalance}.`,
              text: response?.data?.message,
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            });
        handleClose();
      } else {
        CustomAlert({
          title: "Failed to Process Request",
          text: response.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      // setLoading(false);
    }
  };

  const handleAuth = () => {
    setShowAuthModal(true);
  };

  const deleteRequest = () => {
    const requestBody = {
      username: loggedInUserName,
      customerCode: customerCode,
      utrNo: utrNo,
      bankName: bankName,
      status: "3",
    };

    axiosPostApi(apiList.AUTH_MAIN_WALLET_REQ, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          handleClose();
          fetchData(1);
        } else {
          CustomAlert({
            title: "Failed to Process Request",
            text:
              response.data?.message ||
              "Invalid credentials. Please try again!",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("Error while process", error);
        toast.error("Failed to Process.");
      });
  };

  const fetchAppanTechAccInfo = async () => {
    const payload = {
      username: loggedInUserName,
    };
    try {
      setIsLoading(true);
      const response = await axiosPostApi(
        apiList.FETCH_APPANTECH_ACC_DETAILS,
        payload
      );
      if (response?.status === 200 && response?.data?.respCode === "00") {
        const data = response?.data?.data || [];
        setAccData(data);

        setIsLoading(false);
      } else if (response?.data?.respCode === "01") {
        handleClose();
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleAttachmentClick = (base64String) => {
    const imageSrc = `data:image/jpeg;base64,${base64String}`;

    let scale = 1;

    const handleZoom = (event) => {
      event.preventDefault();
      const zoomImage = document.getElementById("zoomable-image");
      if (!zoomImage) return;

      const rect = zoomImage.getBoundingClientRect();

      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;

      const originX = (offsetX / rect.width) * 100;
      const originY = (offsetY / rect.height) * 100;

      zoomImage.style.transformOrigin = `${originX}% ${originY}%`;

      if (event.deltaY < 0) {
        scale += 0.1;
      } else {
        scale = Math.max(1, scale - 0.1);
      }

      zoomImage.style.transform = `scale(${scale})`;
    };

    Swal.fire({
      html: `
                                  <div style="position: relative; overflow: hidden; max-width: 100%; text-align: center;">
                                    <img 
                                      src="${imageSrc}" 
                                      alt="Attachment Image" 
                                      id="zoomable-image" 
                                      style="max-width: 80%; transition: transform 0.3s ease;"
                                    />
                                  </div>
                                `,
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        image: "swal-custom-image",
      },
      willOpen: () => {
        const zoomImage = document.getElementById("zoomable-image");
        zoomImage?.addEventListener("wheel", handleZoom);
      },
      willClose: () => {
        const zoomImage = document.getElementById("zoomable-image");
        zoomImage?.removeEventListener("wheel", handleZoom);
      },
    });
  };

  const formatToInputDate = (dateStr) => {
    // If already in YYYY-MM-DD, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;

    const parts = dateStr.split("-");
    if (parts.length === 3) {
      // Handle DD-MM-YYYY
      const [day, month, year] = parts;
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return "";
  };

  return (
    <>
      <div
        className={`modal-lg modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title main-title">{modalTitle}</h5>
            </div>
            <form>
              <div className="scoped-modal modal-body">
                {action === "add" ||
                action === "view" ||
                action === "auth" ||
                action === "delete" ||
                action === "modify" ||
                action === "check" ? (
                  <>
                    {isMakerChecker && (
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="userId">User Id</label>
                            <input
                              type="text"
                              className="form-control"
                              id="userId"
                              placeholder="0"
                              value={columnData?.username}
                              style={{
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="companyId">Company Id</label>
                            <input
                              type="text"
                              className="form-control"
                              id="companyId"
                              placeholder="0"
                              value={columnData?.customerId}
                              style={{
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="companyName">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              id="companyName"
                              placeholder="0"
                              value={columnData?.customerCompanyName}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="bankName">
                            Company Bank Name
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            className="form-control"
                            id="bankName"
                            value={
                              formData.bankName || columnData?.customerBankName
                            }
                            onChange={handleInputChange}
                            disabled={isReadOnly || loading || error}
                            style={{ appearance: "listbox" }}
                          >
                            <option value="">Select Bank</option>
                            {loading ? (
                              <option disabled>Loading...</option>
                            ) : error ? (
                              <option disabled>Error loading banks</option>
                            ) : (
                              bankNames?.map((bank) => (
                                <option key={bank.bankId} value={bank.bankName}>
                                  {bank.bankName}
                                </option>
                              ))
                            )}
                          </select>
                          {errors.bankName &&
                          !isReadOnly &&
                          !loading &&
                          !error ? (
                            <span className="error">{errors.bankName}</span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-4">
                        {isReadOnly ? (
                          <div className="form-group">
                            <label htmlFor="txnDate">
                              Transaction Date
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="txnDate"
                              value={columnData?.txnDate}
                              onChange={handleInputChange}
                              disabled={isReadOnly}
                            />
                            {errors.txnDate && !isReadOnly ? (
                              <span className="error">{errors.txnDate}</span>
                            ) : null}
                          </div>
                        ) : (
                          // <div className="form-group">
                          //   <label htmlFor="txnDate">
                          //     Transaction Date
                          //     <span style={{ color: "red" }}>*</span>
                          //   </label>
                          //   <input
                          //     type="date"
                          //     className="form-control"
                          //     id="txnDate"
                          //     // value={formData.txnDate || columnData?.txnDate}
                          //     value={
                          //       (formData.txnDate &&
                          //         formatToInputDate(formData.txnDate)) ||
                          //       (columnData?.txnDate &&
                          //         formatToInputDate(columnData.txnDate)) ||
                          //       ""
                          //     }
                          //     onChange={handleInputChange}
                          //     max={new Date().toISOString().split("T")[0]} // Prevent future dates
                          //     min={
                          //       new Date(
                          //         new Date().setMonth(new Date().getMonth() - 6)
                          //       )
                          //         .toISOString()
                          //         .split("T")[0]
                          //     } // 6 months ago
                          //     disabled={isReadOnly}
                          //   />
                          //   {errors.txnDate && !isReadOnly ? (
                          //     <span className="error">{errors.txnDate}</span>
                          //   ) : null}
                          // </div>
                          <div className="form-group">
                            <label htmlFor="txnDate">
                              Transaction Date
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              id="txnDate"
                              value={formData.txnDate || columnData?.txnDate}
                              onChange={handleInputChange}
                              max={new Date().toISOString().split("T")[0]} // Prevent future dates
                              disabled={isReadOnly}
                            />
                            {errors.txnDate && !isReadOnly ? (
                              <span className="error">{errors.txnDate}</span>
                            ) : null}
                          </div>
                        )}
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="payMode">
                            Payment Mode<span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            className="form-control"
                            id="payMode"
                            value={formData.payMode || columnData?.payMode}
                            onChange={handleInputChange}
                            disabled={isReadOnly}
                            style={{ appearance: "listbox" }}
                          >
                            <option value="">Select Payment Mode</option>
                            <option value="NEFT">NEFT</option>
                            <option value="RTGS">RTGS</option>
                            <option value="IMPS">IMPS</option>
                            <option value="UPI">UPI</option>
                          </select>
                          {errors.payMode && !isReadOnly ? (
                            <span className="error">{errors.payMode}</span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="utrNo">
                            UTR No/Transaction No
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="utrNo"
                            placeholder="Enter UTR No/Txn No"
                            value={formData.utrNo || columnData?.utrNo}
                            onChange={handleInputChange}
                            disabled={isReadOnly}
                          />
                          {errors.utrNo && !isReadOnly ? (
                            <span className="error">{errors.utrNo}</span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-4">
                        {isReadOnly ? (
                          <div
                            className="form-group"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              marginTop: "20px",
                            }}
                          >
                            <label htmlFor="attachment">
                              Attachment(Receipt)
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <GrAttachment
                              className="icon-spacing"
                              title="View Attachment"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleAttachmentClick(columnData?.attachment)
                              }
                            />
                          </div>
                        ) : (
                          <div className="form-group">
                            <label htmlFor="attachment">
                              Attachment(Receipt)
                              <i
                                className="info-icon"
                                title="Only image file with .png, .jpeg, .jpg extension allowed"
                                style={{
                                  marginLeft: "8px",
                                  cursor: "pointer",
                                  color: "#007bff",
                                  fontStyle: "normal",
                                  border: "1px solid #007bff",
                                  borderRadius: "50%",
                                  padding: "0 5px",
                                  fontSize: "12px",
                                  display: "inline-block",
                                  width: "16px",
                                  height: "16px",
                                  textAlign: "center",
                                  lineHeight: "16px",
                                }}
                              >
                                i
                              </i>
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              id="attachment"
                              accept=".jpg,.jpeg,.png"
                              onChange={handleFileChange}
                              disabled={isReadOnly}
                            />
                            {errors.attachment && !isReadOnly ? (
                              <span className="error">{errors.attachment}</span>
                            ) : null}
                          </div>
                        )}
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="mainWalletBalance">
                            Main Wallet Balance
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="mainWalletBalance"
                            placeholder="0"
                            value={
                              isReadOnly
                                ? columnData?.customerOldBalance
                                : currentMainBalance
                            }
                            style={{
                              textAlign: "right",
                              cursor: "not-allowed",
                            }}
                            readOnly={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label htmlFor="topupAmount">
                          Top-up Amount(Rs)
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            id="topupAmount"
                            placeholder="0.00"
                            value={
                              formData.topupAmount?.trim() ||
                              columnData?.amount?.trim()
                            }
                            style={{ textAlign: "right" }}
                            onChange={handleInputChange}
                            disabled={isReadOnly}
                          />
                          {errors.topupAmount && !isReadOnly ? (
                            <span className="error">{errors.topupAmount}</span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="totalAmount">Total Amount(Rs)</label>
                          <input
                            type="text"
                            className="form-control"
                            id="totalAmount"
                            placeholder="0.00"
                            value={
                              formData.totalAmount
                                ? formatNumberWithCommas(
                                    formData.totalAmount?.trim()
                                  )
                                : columnData?.customerNewBalance?.trim()
                            }
                            style={{
                              textAlign: "right",
                              cursor: "not-allowed",
                            }}
                            readOnly={true}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        {isReadOnly ? (
                          <div className="form-group">
                            <label htmlFor="companybankName">
                              AppanTech Bank Name
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="companybankName"
                              placeholder="Enter UTR No"
                              value={columnData?.bankName}
                              onChange={handleInputChange}
                              disabled={isReadOnly}
                            />
                            {errors.companybankName && !isReadOnly ? (
                              <span className="error">
                                {errors.companybankName}
                              </span>
                            ) : null}
                          </div>
                        ) : (
                          <div className="form-group">
                            <label htmlFor="companybankName">
                              AppanTech Bank Name
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <select
                              className="form-control"
                              id="companybankName"
                              value={
                                formData.companybankName || columnData?.bankName
                              }
                              // onChange={() => setSelectedComBankName(formData)}
                              onChange={handleInputChange}
                              onClick={() =>
                                accData?.length !== 0 && fetchAppanTechAccInfo()
                              }
                              disabled={isReadOnly || loading || error}
                              style={{ appearance: "listbox" }}
                            >
                              <option value="">
                                {action === "modify" || action === "check"
                                  ? columnData?.bankName
                                  : "Select Bank"}
                              </option>
                              {loading ? (
                                <option disabled>Loading...</option>
                              ) : error ? (
                                <option disabled>Error loading banks</option>
                              ) : (
                                accData?.map((bank) => (
                                  <option key={bank.id} value={bank?.bankName}>
                                    {bank?.bankName}
                                  </option>
                                ))
                              )}
                            </select>
                            {errors.companybankName &&
                            !isReadOnly &&
                            !loading &&
                            !error ? (
                              <span className="error">
                                {errors.companybankName}
                              </span>
                            ) : null}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row mb-3">
                      {(formData?.companybankName ||
                        isReadOnly ||
                        action === "modify") && (
                        <>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="accNo">Account No</label>
                              <input
                                type="text"
                                className="form-control"
                                id="accNo"
                                value={
                                  formData?.accNo || columnData?.companyAccNo
                                }
                                style={{
                                  // textAlign: "right",
                                  cursor: "not-allowed",
                                }}
                                readOnly={true}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="ifsc">IFSC</label>
                              <input
                                type="text"
                                className="form-control"
                                id="ifsc"
                                value={
                                  formData?.ifsc || columnData?.companyBankIfsc
                                }
                                style={{
                                  // textAlign: "right",
                                  cursor: "not-allowed",
                                }}
                                readOnly={true}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="mainWalletBalance">Customer code</label>
                        <input
                          type="text"
                          className="form-control"
                          id="mainWalletBalance"
                          placeholder="0"
                          value={customerCode}
                          style={{ textAlign: "right", cursor: "not-allowed" }}
                          readOnly={true}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="scoped-modal modal-footer">
                <button
                  type="button"
                  className="btn btn-back"
                  onClick={handleBack}
                >
                  Back
                </button>
                {!isReadOnly && (action === "add" || action === "modify") && (
                  <button
                    type="button"
                    className="btn btn-submit"
                    onClick={handleSubmit}
                    disabled={columnData?.authStatus === "APPROVED"}
                  >
                    {action === "modify" ? "Update" : "Submit"}
                  </button>
                )}
                {(action === "auth" || action === "check") && (
                  <button
                    type="button"
                    className="btn btn-submit"
                    onClick={handleAuth}
                    disabled={columnData?.authStatus === "APPROVED"}
                  >
                    Next
                  </button>
                )}
                {action === "delete" && (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={(e) => deleteRequest()}
                  >
                    Reject
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
      <AuthorizationModal
        show={showAuthModal}
        handleClose={() => setShowAuthModal(false)}
        callApi={authMainWalletRequest}
      />
    </>
  );
};

export default TopUpWalletModal;
